import { useState } from "react";
import { SlTab, SlTabGroup, SlTabPanel } from "@shoelace-style/shoelace/dist/react";
import CampaignReport1 from "./CampaignReport1";
import CampaignInfo from "./CampaignInfo";
import FilterBar from "./FilterBar";

const getCurrentMonth = () => new Date().toISOString().slice(0, 7);

// Declare which filters each tab needs
const TAB_FILTERS = {
    "report-1": { showMonth: true, showBrandType: true, showSalesPerson: true },
    "campaign-info": { showMonth: true, showSalesPerson: true, showBrand: true },
};

const CampaignReportsTab = () => {
    const [activeTab, setActiveTab] = useState("report-1");
    const [month, setMonth] = useState(getCurrentMonth());
    const [brandType, setBrandType] = useState(null);
    const [salesPerson, setSalesPerson] = useState(null);
    const [brand, setBrand] = useState(null);

    const filters = TAB_FILTERS[activeTab] || {};

    const handleTabChange = (e) => {
        setActiveTab(e.detail.name);
        // Reset dependent filters when switching tabs
        setBrandType(null);
        setSalesPerson(null);
        setBrand(null);
    };

    return (
        <div className="flex flex-col min-h-0">
            <FilterBar
                {...filters}
                month={month}
                onMonthChange={setMonth}
                brandType={brandType}
                onBrandTypeChange={setBrandType}
                salesPerson={salesPerson}
                onSalesPersonChange={setSalesPerson}
                brand={brand}
                onBrandChange={setBrand}
            />

            <SlTabGroup onSlTabShow={handleTabChange}>
                <SlTab slot="nav" panel="report-1">
                    Report 1
                </SlTab>
                <SlTab slot="nav" panel="campaign-info">
                    Campaign Info
                </SlTab>

                <SlTabPanel name="report-1">
                    {activeTab === "report-1" && (
                        <CampaignReport1
                            month={month}
                            brandType={brandType}
                            salesPerson={salesPerson}
                        />
                    )}
                </SlTabPanel>

                <SlTabPanel name="campaign-info">
                    {activeTab === "campaign-info" && (
                        <CampaignInfo
                            month={month}
                            salesPerson={salesPerson}
                            brand={brand}
                        />
                    )}
                </SlTabPanel>
            </SlTabGroup>
        </div>
    );
};

export default CampaignReportsTab;
